class exports.FullPageHandler extends DialogHandler
    constructor: (name, opts) ->
        super(name, opts)

        @refreshNavHandler = false

        @draggable = false
        @resizable = false
        @startPosition = null
        @slideUpForm = false
        @modalOptions =
            keyboard: false

        @destroyOnSave = false


    createDialog: (loadOpts = {}) ->
        super(loadOpts)
        @dialog.on 'shown', (e) =>
            modal = @dialog.find('.modal-body')
            parent = modal.parents('div')
            modal.resizr
                parent_selector: parent

            @_handleResize()

        @dialog.addClass('fullpage_dialog')

        if @useMessageWriter
            @dialog.find('.message_writer').addClass 'absolute-errorDiv'


    openDialog: () ->
        super()
        @dialog.find('.modal-body').resizr()

        if @useMessageWriter
            @dialog.find('.message_writer').addClass 'absolute-errorDiv'
            if @dialog.find('.message_writer').message_writer().length isnt 0
                @dialog.find('.message_writer').message_writer 'setInitialClass'

        $(window).smartresize () =>
            @_handleResize()


        App.map?.on 'resize', () =>
            @_handleResize()


    _handleResize: () ->
        top = $('#primary_header').outerHeight()
        left = App.sidebar.element.outerWidth(true)

        sidebarWidth = App.sidebar.element.outerWidth(true)
        sidebarLeftOffset = App.sidebar.element.offset().left
        left = sidebarWidth + sidebarLeftOffset

        topbuffer = @topBuffer?() ? -1

        height = $(window).height() - top
        width = $(window).width() - left
        @dialog.css
            left: '-1px'
            top: topbuffer + 'px'
            marginLeft: left + 'px'
            marginTop: top + 'px'
            height: height + 'px'
            width: width + 'px'

        @dialog.find('.modal-body').resizr()
        #@dialog.find('.modal-body').resizr 'resize'
        $(window).trigger('modal_resized')
